import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-accidents-redirect',
  template: '',
})
export class AccidentsRedirectComponent implements OnInit {

  urlRedirect = environment.REPORT_ACCIDENT_REDIRECT;

  constructor(
    private router: Router,
  ) { }


  ngOnInit() {
    this.redirect();
  }

  redirect() {
    window.open(this.urlRedirect, '_blank');
    this.irHome();
  }

  irHome() {
    setTimeout(() => {
      this.router.navigate(['/home']);
    }, 450);

  }

}
